
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
import dayjs from "dayjs";
import appCode from "@common/src/utils/app-code";
import { splitThousands, emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import CustomeShortcut from "./components/custome-shortcut.vue";

const app = namespace("app");
const store = namespace("store");
const dashboard = namespace("dashboard");
const service = namespace("service");
const finance = namespace("finance");
const setting = namespace("setting");

@Component({
  components: { CustomerFlag, TextTips, CustomeShortcut }
})
export default class Dashboard extends Vue {
  @app.State test;
  @dashboard.Action getHomeOrderData;
  @dashboard.Action getHomeCustomerData;
  @dashboard.Action getOrderStatistic;
  @service.Action getAppointmentCalender;
  @dashboard.Action getAnnouncementList;
  @store.State storeData;
  @finance.Action statisticOnAccount;
  @finance.Mutation setAccountCurrentTabType;
  @app.State dashboardShowModeAlert;
  @app.Mutation setDashboardShowModeAlert;
  @setting.State serviceModeDesc;
  @dashboard.Action saveCustomFeature;
  @dashboard.Action queryAllAndCostomFeature;
  addCurrencyUnit = addCurrencyUnit;
  splitThousands = splitThousands;
  addCurrencySymbol = addCurrencySymbol;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  get statusBarData() {
    return [
      {
        statusName: t("dashboard.wait-take-out"),
        statusNum: this.gt99Set(this.orderNums[0])
      },
      {
        statusName: t("dashboard.waiting"),
        statusNum: this.gt99Set(this.orderNums[1])
      },
      {
        statusName: t("dashboard.settlement"),
        statusNum: this.gt99Set(this.orderNums[2])
      }
    ];
  }
  orderNums: number[] = [0, 0, 0];
  taskList: any[] = [];
  currentStatus: number = 0;
  orderData: any = [];
  storeCode: any = [];
  customerData: any = [];
  orderListData: any[] = [];
  freshDate: string = "";
  weekDataList: any = []; // 最近七天数据
  currentLookDay: string = dayjs().format("DD");
  loadingStatistic: boolean = false; // 首页统计数据加载完成控制
  created() {
    this.init();
    setInterval(this.scroll, 5000); //公告间隔时间控制
    console.log("appCode", appCode);
  }
  handleLink(item) {
    window.open(this.$router.resolve(item.resourceUrl).href);
  }
  handleLinkOrderInfo(id) {
    this.$router.push(`/service/view/${id}`);
  }
  handleLinkCustomer(task) {
    if (!task.customerCode) return false;
    this.$router.push(`/setting/customer-view/${task.customerCode}?vehicleCode=${task.vehicleCode}`);
  }
  hasTmallOrder: boolean = false;
  weekDescMap: any = {
    "1": t("base.monday"),
    "2": t("base.tuesday"),
    "3": t("base.wednesday"),
    "4": t("base.thursday"),
    "5": t("base.friday"),
    "6": t("base.saturday"),
    "0": t("base.sunday")
  };
  customFeatureList: any = [];
  init() {
    this.freshDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.getHomeOrderData().then(data => {
      this.orderData = this.$safeValue(data, "data", {});
    });
    this.getHomeCustomerData().then(data => {
      this.customerData = data.data;
    });
    this.getAnnouncementList({
      storeCode: this.storeData.storeCode
    }).then(data => {
      this.noticelist = this.$safeValue(data, "data", []);
    });
    this.getLastOneWeekAppointment();
    this.loadingStatistic = true;
    this.getOrderStatistic()
      .then(data => {
        this.orderNums = [
          data.data?.receiveMaterialsCount || 0,
          data.data?.unfinishedCount || 0,
          data.data?.unSettlementCount || 0
        ];
        this.orderListData = [
          data.data.receiveMaterialsOrderArray,
          data.data.unfinishedOrderArray,
          data.data.unSettlementOrderArray
        ];
        this.hasTmallOrder = data.data.unfinishedOrderArray.some(item => {
          return item.orderSource === "2";
        });
        this.handleSwitchStatus(1);
      })
      .finally(() => {
        this.loadingStatistic = false;
      });
    this.queryCustomeFeature();
  }
  queryCustomeFeature() {
    this.queryAllAndCostomFeature().then(data => {
      this.customFeatureList = (data.data?.selectedOptionList || []).map(item => {
        item.pictureUrl = `https://static.gtech.asia/static/speedbiz/quick_entry/icon/pc/${item.iconCode}.png`;
        return item;
      });
    });
  }
  refreshData() {
    this.init();
  }
  // 大于99 改成99+
  gt99Set(num) {
    return num > 99 ? "99+" : num;
  }
  getLastOneWeekAppointment() {
    this.getAppointmentCalender({
      queryDays: 7
    }).then(data => {
      let appointmentList = this.$safeValue(data, "data.list", []);
      let tempWeekData = [];
      let curDate = dayjs();
      for (let index = 0; index < 7; index++) {
        let tempDate = curDate.add(index, "day");
        let fullDateStr = tempDate.format("YYYYMMDD");
        let reuslt = appointmentList.find(item => {
          return item.date === fullDateStr;
        });
        tempWeekData.push({
          inCount: reuslt ? reuslt.reservationOrders.length : 0,
          month: tempDate.format("MM"),
          fullDate: fullDateStr,
          weekDesc:
            index === 0 ? t("base.today") : index === 1 ? t("base.tomorrow") : this.weekDescMap[tempDate.get("day")],
          day: tempDate.format("DD")
        });
      }
      this.weekDataList = tempWeekData;
    });
  }
  animate: any = false;
  noticelist: any = [];
  scroll() {
    this.animate = true;
    if (this.noticelist && this.noticelist.length === 1) {
      this.animate = false; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
    }
    setTimeout(() => {
      this.noticelist.push(this.noticelist[0]); // 将数组的第一个元素添加到数组的
      this.noticelist.shift(); //删除数组的第一个元素
      this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
    }, 500);
  }

  handleViewAllOrder() {
    let { href } = this.$router.resolve({
      path: `/service/index`
    });
    window.open(href, "_blank");
  }
  handleClickSomeday(dayData) {
    this.currentLookDay = dayData.day;
    let { href } = this.$router.resolve({
      path: `/service/index?date=${dayData.fullDate}&type=all`
    });
    window.open(href, "_blank");
  }
  handleSwitchStatus(i) {
    this.currentStatus = i;
    this.taskList = this.orderListData[i].map(item => {
      item.showTimeDesc = t("dashboard.created-time");
      item.showTime = item.orderTime;
      return item;
    });
  }
  @Watch("$route")
  watchRoute(val) {
    if (val.path === "/index") {
      this.init();
    }
  }
  goLook() {
    this.setAccountCurrentTabType("charge-more-month-order");
    this.$router.push("/finance/on-account-manage");
  }
  showCustomShortcut = false;
  handleShowCustomShortcut() {
    this.showCustomShortcut = true;
  }
  handleReceiveShortcutList(list) {
    this.saveCustomFeature({
      resourceCodeList: list.map(item => item.resourceCode)
    }).then(() => {
      this.showCustomShortcut = false;
      this.$message.success(t("base.save-success"));
      this.queryCustomeFeature();
    });
  }
  dayDefaultKey = "";
  handleToAnalysis(type) {
    this.$router.push(`/finance/report-business-detail?incomeExpenseType=${type}`);
  }
  handleToDpPage(type) {
    this.$router.push("/finance/deferred-payment/index?dashboard=" + type);
  }
}
